import React from "react";
import useSearchParam from "../../Hooks/useSearchParam";
import {
  IPortfolioInsTableExtraData,
  IPortfolioInsTableSearchParams,
} from "../../Interfaces/portfolio";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { getStepInstruments } from "../../Requests/stepRequests";
import { getUsers } from "../../Requests/portfolioRequests";
import Button from "../../Components/Button";
import PortfoInsTable from "../../Tables/Portfolio/PortfoInsTable";
import { printPrice } from "../../helper";

const InsTableWrapper = () => {
  const [extraData, setExtraData] = React.useState<
    IPortfolioInsTableExtraData[] | null
  >(null);
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({
    initialSearchParam: {} as IPortfolioInsTableSearchParams,
  });

  return (
    <div className="flex flex-col justify-start items-start gap-2 w-full">
      <div className="flex flex-row justify-start items-end gap-2 p-2">
        <div className="w-[250px]">
          <DynamicDropdown
            dropdown={{
              name: "accountId",
              placeholder: "نام اکانت",
            }}
            getData={getUsers}
            onChange={clientSearchParamChangeHandler}
            value={clientSearchParams.accountId}
          />
        </div>
        <div className="w-[250px]">
          <DynamicDropdown
            dropdown={{
              name: "instrumentId",
              placeholder: "نماد",
              extraLabel: true,
            }}
            getData={() => getStepInstruments()}
            onChange={clientSearchParamChangeHandler}
          />
        </div>
        <div className="w-min">
          <Button onClick={onSubmit} text="جستجو" variant="contained" />
        </div>
      </div>
      {extraData != null && extraData.length > 0 && (
        <div className="flex gap-5 self-center">
          <span className="text-sm bold">
            مجموع موجودی: {printPrice(extraData[0].balance)}
          </span>
          <span className="text-sm bold">
            مجموع ارزش: {printPrice(extraData[0].value)}
          </span>
        </div>
      )}
      <PortfoInsTable
        searchParams={serverSearchParams}
        onExtraDataChange={setExtraData}
      />
    </div>
  );
};

export default InsTableWrapper;
